import { Space, Typography } from 'antd';
import { useTheme } from 'styled-components';

interface Props {
  title: string;
  subtitle: string;
}

export function PlaceholderCategoryGroupMenuLabel(props: Props) {
  const { title, subtitle } = props;
  const theme = useTheme();

  return (
    <Space>
      <Typography.Text
        strong
        style={{ textTransform: 'uppercase', color: theme.colorPrimary }}
      >
        {title}
      </Typography.Text>
      <Typography.Text type="secondary">{subtitle}</Typography.Text>
    </Space>
  );
}
